import type { CustomQuickAction } from 'korint-sdk/react';

type CustomQuickActionDialogProps = {
  action: CustomQuickAction;
  onClose: () => void;
};

export function CustomQuickActionDialog({ action, onClose }: CustomQuickActionDialogProps) {
  const Dialog = action.dialog;

  return <Dialog onClose={onClose} />;
}
